import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class StreamDownloadFetch {
  endpoint = environment.apiUrl + 'PLD/administraciontransacciones/';
  endpointCasos = environment.apiUrl + 'PLD/administracionCasos/';
  endpointPersonas = environment.apiUrl + 'Personas/Persona/';

  //endpoint = 'https://localhost:65285/' + 'administraciontransacciones/';
  //endpointCasos = 'https://localhost:65285/' + 'administracionCasos/';
  //endpointPersonas = 'https://localhost:53077/' + 'Persona/';

  constructor() {}

  async openBrowserWindowZip(fileName: string) {
    const handle = await (window as any).showSaveFilePicker({
      suggestedName: `${fileName}_${Date.now()}.zip`,
      types: [{
        description: 'ZIP',
        accept: { 'application/zip': ['.zip'] }
      }]
    });

  const writable = await handle.createWritable();
  return { handle, writable };
  }

  async Transacciones(payload: any, signal: AbortSignal): Promise<Response> {
    const resp = await fetch(
      `${this.endpoint}streamDownloadTransacciones`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload), signal
      }
    );

    if(!resp.ok){
      let msg = `HTTP ${resp.status}`;
      try{
        msg = await resp.text();
      } catch{}
      throw new Error(msg);
    }

    return resp;
  }

  async Casos(payload: any, signal: AbortSignal): Promise<Response> {
    const resp = await fetch(
      `${this.endpointCasos}streamDownloadCasos`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload), signal
      }
    );

    if(!resp.ok){
      let msg = `HTTP ${resp.status}`;
      try{
        msg = await resp.text();
      } catch{}
      throw new Error(msg);
    }

    return resp;
  }

  async Personas(payload: any, signal: AbortSignal): Promise<Response> {
    const resp = await fetch(
      `${this.endpointPersonas}streamDownloadPersonas`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload), signal
      }
    );

    if(!resp.ok){
      let msg = `HTTP ${resp.status}`;
      try{
        msg = await resp.text();
      } catch{}
      throw new Error(msg);
    }

    return resp;
  }


}


